import { Component, Inject, Input, NgZone, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FlowService } from "../../flow/flow.service";
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { UIConfigService } from 'src/app/shared/services/UIConfigService';
import { FlowTriggerService } from '../flow.trigger.service';

/**
 * FlowFormComponent
 *
 * This component is responsible for rendering a dynamic form based on a flow's trigger configuration.
 * When a flow has a trigger_type of 'form', this component transforms the flow's payload_data
 * into a form structure that can be displayed to the user.
 */
@Component({
    selector: 'app-flow-form',
    templateUrl: './flow-form.component.html',
    styleUrls: ['./flow-form.component.scss'],
    standalone: false
})
export class FlowFormComponent implements OnInit {

  error = false;
  authError: boolean = false;
  spinner: boolean = false
  isBrowser: boolean;
  routerSubscriptionParams: any;
  workspace: any;
  errorMsg: string;
  isReady: boolean = false;

  @Input() "flow": any;

  constructor(
    public router: Router,
    public fs: FlowService,
    public authService: AuthServiceService,
    // private spinner: SpinnerService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private ngZone: NgZone,
    public connectionService: ConnectionService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) platformId: Object,
    public workspaceService: WorkspaceService,
    public flowTriggerService: FlowTriggerService,
    public uic: UIConfigService
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
   }

  /**
   * Initialize the component and subscribe to route parameters
   * to get the flow ID and fetch the flow data
   */
  async ngOnInit() {
    if(!this.isBrowser) return; // Skip initialization if not running in browser
    this.routerSubscriptionParams = this.route.params.subscribe(async (params:any) => {
      let id = params['id'] || this.flow;
      await this.flowTriggerService.getFlowAndFormStructure(id) // Get flow data using ID from route params
      this.isReady = true;
    })
  }

}
